module.exports = __webpack_public_path__ + "img/logo.6ec02626.png";